/* eslint-disable no-console */
import { connect } from 'react-redux';
import initWrapper from '../initWrapper';
import { safeGet } from '../../utils/storage';
import { gridPrefix } from './gridUtils';
import { getDecodedUser } from '../../utils/login';

import {
  dataInit,
  dataLoad,
  dataFilterRemove,
  dataFilterResetValue,
  dataFilterResetValues,
  dataFilterEdit,
  dataFilterAdd,
  dataFilterDefault,
  dataPageSize,
  dataPage,
  dataSort,
  dataOrder,
  dataFilterOpen,
} from './dataActions';

export const Order = { DESC: 'DESC', ASC: 'ASC' };
export const FilterOperation = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  GT: 'GT',
  LT: 'LT',
  GTE: 'GTE',
  LTE: 'LTE',
  STARTWITH: 'STARTWITH',
  ENDWITH: 'ENDWITH',
  CONTAINS: 'CONTAINS',
  NEGATE: 'NEGATE',
  IS_NULL: 'IS_NULL',
  NOT_NULL: 'NOT_NULL'
};

export default (dataId, defaultProps, Component, stateFull = true) => {
  const gridName = `${dataId}_${getDecodedUser().sub || 'notLogged'}`; 
  const mapStateToProps = ({ grid }) => grid[gridName];
  const savedProps = stateFull ? safeGet(gridPrefix + gridName) || {} : {};

  const mapDispatchToProps = dispatch => ({
    onLoad: () => dispatch(dataLoad(gridName)),
    onFilterRemove: filter => dispatch(dataFilterRemove(gridName, filter)),
    onFilterResetValue: filter => dispatch(dataFilterResetValue(gridName, filter)),
    onFilterResetValues: filter => dispatch(dataFilterResetValues(gridName)),
    onFilterEdit: (filter, newFilter) => dispatch(dataFilterEdit(gridName, filter, newFilter)),
    onFilterAdd: () => dispatch(dataFilterAdd(gridName)),
    onFilterLoadDefault: (filters) => dispatch(dataFilterDefault(gridName, filters)),
    onPageSizeChange: size => dispatch(dataPageSize(gridName, size)),
    onPageChange: page => dispatch(dataPage(gridName, page)),
    onSortChange: sort => dispatch(dataSort(gridName, sort)),
    onOrderChange: order => dispatch(dataOrder(gridName, order)),
    onFilterOpen: isOpen => dispatch(dataFilterOpen(gridName, isOpen)),
  });

  return initWrapper(
    dataInit(gridName, { ...defaultProps, ...savedProps }),
    connect(mapStateToProps, mapDispatchToProps)(Component),
  );
};
